module.exports = __webpack_public_path__ + "static/media/arrow.500f52ce.svg";